import { createApi } from '@reduxjs/toolkit/query/react';
import { GetCourseDetails } from '../../api/endpoints';
import {baseQueryWithReauth} from "../../api/baseQuery";


export const courseDetailsApi = createApi({
  reducerPath: 'courseDetailsApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getCourseDetails: builder.query({
      query: (courseId) => ({ url: GetCourseDetails, method: 'POST', body: { courseId } }),
    }),
  }),
})

export const { useGetCourseDetailsQuery } = courseDetailsApi;
